import { ChangeDetectionStrategy, Component } from '@angular/core'
import { LEAVE_SYNC_CLASS, LeaveSyncDirective } from '@mos/client/shared/utils'

@Component({
	selector: 'mos-header',
	imports: [],
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	// Widely-reused leaf atom - hostDirectives applied proactively per docs/animations-migration.md's
	// policy note, so its leave stays synced whenever an ancestor (most `mos-*-modal`s) tears it down.
	hostDirectives: [LeaveSyncDirective],
	providers: [{ provide: LEAVE_SYNC_CLASS, useValue: 'header-out' }],
	host: {
		'animate.enter': 'header-in',
	},
})
export class HeaderComponent {}
